export const getCookie = (name) => {
  let arr;
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
};

let agency = getCookie('AGENCY_TYPE');
const agencyList = agency ? agency.split('|') : [];

export const hasType = (type) => {
  if (agencyList.includes(type)) {
    return true;
  }
  return false;
};

export const getTypeArray = () => {
  return agencyList;
};



// WEBPACK FOOTER //
// ./src/components/util/checkAgencyType.js